import { render, staticRenderFns } from "./TabInfo.vue?vue&type=template&id=60ab1c4c&scoped=true"
import script from "./TabInfo.vue?vue&type=script&lang=ts"
export * from "./TabInfo.vue?vue&type=script&lang=ts"
import style0 from "./TabInfo.vue?vue&type=style&index=0&id=60ab1c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ab1c4c",
  null
  
)

export default component.exports